// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.LinearGaugeConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import cfgFactories from 'share/factories/Izenda.ReportPartStyleConfigurationFactories';
import localizer from 'share/localization/Izenda.Localizer';
import LinearGaugeOptionsBuilder from './Izenda.LinearGaugeOptionsBuilder';
import CommonGaugeFieldContainerSchema from './Izenda.CommonGaugeFieldContainerSchema';

import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';

import { MappingValues, CHART_TYPE } from 'logic/data/Izenda.ChartDefaultConfig';
import VISUAL_TYPE from 'share/components/charting/highcharts/Izenda.VisualTypeMapping';

const { ZOOM_TYPE_VALUES } = MappingValues;

cfgFactories.extendConfiguration(REPORT_PART_TYPE.Gauge, CHART_TYPE.LinearGauge, null, {
  visualType: VISUAL_TYPE.LinearGauge,

  get visualLabel() {
    return localizer.getText('REPORT_PART_GAUGE_CONSTANTS_LABEL_LINEAR_GAUGE');
  },

  visualPreviewCSS: 'gauge-linear',

  optionsBuilder: LinearGaugeOptionsBuilder,

  fieldContainerSchema: CommonGaugeFieldContainerSchema,

  optionsMapping: {
    optionsByType: {
      izInverted: { propKey: 'chart.inverted', defaultValue: false },
      izIntervals: { propKey: 'izendaOptions.intervals', defaultValue: undefined },
      izValueLabel: { propKey: 'plotOptions.series.dataLabels.enabled', defaultValue: false },
      izZoom: { propKey: 'chart.zoomType', propSource: ZOOM_TYPE_VALUES, defaultValue: undefined }
    }
  }
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGauge/Izenda.LinearGaugeConfiguration.js